class EventDispatcher {
    _listeners = null;

    _listenersScopes = null;

    addEventListener(type, listener, scope = null) {
        const listeners = this._listeners || {};
        const listenersScopes = this._listenersScopes || {};

        if (typeof listeners[type] === 'undefined') {
            listeners[type] = [];
            listenersScopes[type] = [];
        }

        if (listeners[type].indexOf(listener) < 0) {
            listeners[type].push(listener);
            listenersScopes[type].push(scope);
        }

        this._listeners = listeners;
        this._listenersScopes = listenersScopes;
    }

    hasEventListener(type, listener, scope = null) {
        if (this._listeners === null) return false;

        const listeners = this._listeners || {};

        if (scope === null) return typeof listeners[type] !== 'undefined' && listeners[type].indexOf(listener) > -1;

        const listenersScopes = this._listenersScopes || {};

        return typeof listeners[type] !== 'undefined'
            && listeners[type].indexOf(listener) > -1
            && listenersScopes[type].indexOf(scope) > -1;
    }

    removeEventListener(type, listener) {
        if (this._listeners === null) return;

        const listenersByType = this._listeners[type];
        const scopesByType = this._listenersScopes[type];

        if (typeof listenersByType === 'undefined') return;

        const index = listenersByType.indexOf(listener);

        if (index < 0) return;

        listenersByType.splice(index, 1);
        scopesByType.splice(index, 1);
    }

    removeAllEventListeners(type) {
        if (typeof type === 'undefined') {
            this._listeners = null;
            this._listenersScopes = null;
        }

        if (typeof this._listeners[type] === 'undefined') return;

        delete this._listeners[type];
        delete this._listenersScopes[type];
    }

    dispatchEvent(event) {
        if (!event || !event.type) return;

        const { type } = event;

        if (this._listeners === null) return;

        let listenersByType = this._listeners[type];
        let scopesByType = this._listenersScopes[type];

        if (typeof listenersByType === 'undefined') return;

        // Make sure that all the current listeners would receive the event instance
        listenersByType = [].concat(listenersByType);
        scopesByType = [].concat(scopesByType);

        event.target = this;

        listenersByType.forEach((listener, index) => {
            listener.call(scopesByType[index] || this, event);
        });
    }
}

export default EventDispatcher;
